import React from 'react';
import { Loader } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {
  paperShape,
  frameShape,
  workShape
} from 'arts/reducers/work';
import * as Classes from './styles.module.scss';
import FrameWithPreview, { renderNoFrame } from './frame_with_preview';

const ImagePreview = ({
  selectedFrame,
  selectedPaper,
  data,
  otherImageUrl
}) => {
  const { wmZoomPreviewUrl: zoomPreviewUrlUsed } = selectedFrame || {};
  let content = null;

  if (otherImageUrl) {
    content = (
      <div className={ Classes.otherImage }>
        <img src={ otherImageUrl } alt="" />
      </div>
    );
  } else {
    const paper = selectedPaper || data.firstPaper;
    if (!paper) {
      content = <Loader active inline />;
    } else if (!selectedFrame || !selectedFrame.frame) {
      content = renderNoFrame(paper, zoomPreviewUrlUsed, data);
    } else {
      const { imageUrl, title } = data;
      content = (
        <FrameWithPreview frame={ selectedFrame }>
          {
            ({ className }) => (
              <img src={ imageUrl } alt={ title } className={ className } width="100%" height="100%" />
            )
          }
        </FrameWithPreview>
      );
    }
  }

  return (
    <div className={ Classes.previews }>
      { content }
    </div>
  );
};

ImagePreview.propTypes = {
  selectedFrame: frameShape,
  selectedPaper: paperShape,
  data: workShape,
  otherImageUrl: PropTypes.string
};

export default ImagePreview;
